import { BehaviorSubject } from 'rxjs/BehaviorSubject';

/** @desc Migration helper class to handle uirouter state changes **/
export class UirouterMigrationService {
  public params = new BehaviorSubject(window.location.hash.split('/'));

  constructor() {
    window.addEventListener(
      'hashchange',
      () => {
        this.params.next(window.location.hash.split('/'));
      },
      false,
    );
  }

  /**
   * @desc Function to handle state changes manually to help with the uirouter migration
   * @param {string} state - The uirouter state string to be moved to
   * @param {object} params - The parameters to be passed to the state
   * @return {void}
   */
  goTo(state: string, params?: any): void {
    const url = '/app/';
    let stateSuffix;
    switch (state) {
      case 'app.seo_edit':
        stateSuffix = `seo/edit/${params.countryId}/${params.destinationId}/${params.categoryId}/${params.language}`;
        break;
      case 'app.chains-create':
        stateSuffix = `chains/create/${params.merchantId ? params.merchantId : ''}`;
        break;
      case 'app.chains-edit':
        stateSuffix = `chains/edit/${params.chainId}`;
        break;
      case 'app.chains':
        stateSuffix = 'chains/';
        break;
      case 'app.collections-config':
        stateSuffix = `collections/${params.destinationName}`;
        break;
    }
    // Update params
    const urlToGo = `/#${url}${stateSuffix}`;
    this.params.next(urlToGo.split('/'));
    // Move to url
    window.history.pushState(null, '', urlToGo);
    window.location.replace(urlToGo);
  }

  /**
   * @desc Function to get needed request parameters
   * @param {string} state - The UI router state to be retrieved
   * @param {array} hash - The array of window hash values
   * @return {object}
   */
  getParams(state: string, hash = window.location.hash.split('/')) {
    switch (state) {
      case 'app.seo_edit':
        return {
          categoryId: parseInt(hash[6], 10),
          destinationId: parseInt(hash[5], 10),
          countryId: hash[4],
          language: hash[7],
        };
      case 'app.chains-create':
        return {
          merchantId: parseInt(hash[hash.length - 1], 10),
        };
      case 'app.chains-edit':
        return {
          chainId: parseInt(hash[hash.length - 1], 10),
        };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/util/uirouter.migration.service.ts